import React, { useEffect, useState } from 'react';
import { Radio } from 'lucide-react';
import { tabletopExercisesAPI, TabletopExercise } from '../../services/tabletopService';
import RunConsolePage from '../../pages/tabletop/RunConsolePage';

interface Props {
  sessionId: string;
  projectId?: string;
}

// Session-linked module tab registration (see sessionModuleTabs.ts) for the
// tabletop run console, so an organiser running a live exercise doesn't have
// to leave LiveSession to reach RunConsolePage. Exercises don't carry a
// reverse index from sessionId back to exerciseId, so this resolves it by
// listing the project's exercises and matching on sessionId — acceptable
// given a project realistically has a handful of tabletop exercises, not
// hundreds.
export const TabletopRunTab: React.FC<Props> = ({ sessionId, projectId }) => {
  const [exercise, setExercise] = useState<TabletopExercise | null | undefined>(undefined);

  useEffect(() => {
    if (!projectId) return;
    tabletopExercisesAPI.list(projectId).then(r => {
      const match = r.data.exercises.find(e => e.sessionId === sessionId && e.currentRunId);
      setExercise(match || null);
    });
  }, [projectId, sessionId]);

  if (!projectId || exercise === undefined) {
    return <div className="flex-1 flex items-center justify-center text-slate-400 text-sm p-8">Loading…</div>;
  }

  if (!exercise) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center text-slate-400 text-sm p-8 gap-2">
        <Radio size={22} className="text-slate-300" />
        No active tabletop run is linked to this session yet.
      </div>
    );
  }

  return <RunConsolePage projectId={projectId} exercise={exercise} onExerciseChange={setExercise} />;
};
